import { render } from "./TemperaturaConverter.vue?vue&type=template&id=28faaddc"
import script from "./TemperaturaConverter.vue?vue&type=script&lang=js"
export * from "./TemperaturaConverter.vue?vue&type=script&lang=js"

import "./TemperaturaConverter.vue?vue&type=style&index=0&id=28faaddc&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__